<datex-grid #$gridComponent *ngIf="initialized " [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

>
    <ng-container topToolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch">
    </div>
  </ng-container>


  <ng-container gridColumnDef="Name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Name.displayControl.styles.style"
          [ngClass]="row.cells.Name.displayControl.styles.classes"
          [matTooltip]="row.cells.Name.displayControl.tooltip">{{row.cells.Name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Description">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Description.displayControl.styles.style"
          [ngClass]="row.cells.Description.displayControl.styles.classes"
          [matTooltip]="row.cells.Description.displayControl.tooltip">{{row.cells.Description.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Length">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Length.displayControl.styles.style"
          [ngClass]="row.cells.Length.displayControl.styles.classes"
          [matTooltip]="row.cells.Length.displayControl.tooltip">{{row.cells.Length.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Width">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Width.displayControl.styles.style"
          [ngClass]="row.cells.Width.displayControl.styles.classes"
          [matTooltip]="row.cells.Width.displayControl.tooltip">{{row.cells.Width.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Height">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Height.displayControl.styles.style"
          [ngClass]="row.cells.Height.displayControl.styles.classes"
          [matTooltip]="row.cells.Height.displayControl.tooltip">{{row.cells.Height.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="DimensionUom_Short_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.DimensionUom_Short_name.displayControl.styles.style"
          [ngClass]="row.cells.DimensionUom_Short_name.displayControl.styles.classes"
          [matTooltip]="row.cells.DimensionUom_Short_name.displayControl.tooltip">{{row.cells.DimensionUom_Short_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Weight">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Weight.displayControl.styles.style"
          [ngClass]="row.cells.Weight.displayControl.styles.classes"
          [matTooltip]="row.cells.Weight.displayControl.tooltip">{{row.cells.Weight.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="WeightCapacity">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.WeightCapacity.displayControl.styles.style"
          [ngClass]="row.cells.WeightCapacity.displayControl.styles.classes"
          [matTooltip]="row.cells.WeightCapacity.displayControl.tooltip">{{row.cells.WeightCapacity.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="WeightUom_Short_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.WeightUom_Short_name.displayControl.styles.style"
          [ngClass]="row.cells.WeightUom_Short_name.displayControl.styles.classes"
          [matTooltip]="row.cells.WeightUom_Short_name.displayControl.tooltip">{{row.cells.WeightUom_Short_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="VolumeUom_Short_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.VolumeUom_Short_name.displayControl.styles.style"
          [ngClass]="row.cells.VolumeUom_Short_name.displayControl.styles.classes"
          [matTooltip]="row.cells.VolumeUom_Short_name.displayControl.tooltip">{{row.cells.VolumeUom_Short_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="volume_capacity">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.volume_capacity.displayControl.styles.style"
          [ngClass]="row.cells.volume_capacity.displayControl.styles.classes"
          [matTooltip]="row.cells.volume_capacity.displayControl.tooltip">{{row.cells.volume_capacity.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="numberBox" [formControl]="row.formGroup.controls['volume_capacity_edit']"
            matInput
            numberBox
            [format]="row.cells.volume_capacity.editControl.format"
            autocomplete="off"
            spellcheck="false"
            class="datex-numberbox {{ (row.cells.volume_capacity.editControl.readOnly || row.cells.volume_capacity.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.volume_capacity.editControl.placeholder}}"
            [ngStyle]="row.cells.volume_capacity.editControl.styles.style"
            [ngClass]="row.cells.volume_capacity.editControl.styles.classes"
            [matTooltip]="row.cells.volume_capacity.editControl.tooltip">
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
